import { render, staticRenderFns } from "./FabBlockButton.vue?vue&type=template&id=e06aecea&scoped=true&"
import script from "./FabBlockButton.vue?vue&type=script&lang=js&"
export * from "./FabBlockButton.vue?vue&type=script&lang=js&"
import style0 from "./FabBlockButton.vue?vue&type=style&index=0&id=e06aecea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06aecea",
  null
  
)

export default component.exports